import {i18n} from './shared/i18n/index';

export const configDefaults = {
        id: 'app-base-library',
        name: 'app-base-library',
        authenticated: false,
        domain: 'app-base-library.firebaseapp.com',
        baseUrl: 'https://app-base-library.firebaseapp.com/',
        baseRoot: 'https://app-base-library.firebaseapp.com',

        api_headers: [
            { 'Content-Type': 'application/json;charset=utf-8' }
        ],

        drupal: {
            domain: 'www.streamer.nl',
            protocol: 'https:',
            app_uuid: '319e0e50-5f1b-4b76-8798-3f89da31dd12',
        },
        wordpress: {
            host: 'www.streamer.nl/wordpress',
            protocol: 'https:',
            base_path: '/',
            //app_server: true
        },


        // todo: deprecate
        firebase: {
            apiKey: 'AIzaSyBQcrVHXEsTDIGj32Cba9ph6rf6mZtbJb4',
            authDomain: 'app-base-library.firebaseapp.com',
            databaseURL: 'https://app-base-library.firebaseio.com',
            projectId: 'app-base-library',
            storageBucket: 'app-base-library.appspot.com',
            messagingSenderId: '468508881249'
        },
        // todo: implement
        firebaseApps: {
            'app-base-library': {
                'apiKey': 'AIzaSyBQcrVHXEsTDIGj32Cba9ph6rf6mZtbJb4',
                'authDomain': 'app-base-library.firebaseapp.com',
                'databaseURL': 'https://app-base-library.firebaseio.com',
                'projectId': 'app-base-library',
                'storageBucket': 'app-base-library.appspot.com',
                'messagingSenderId': '468508881249'
            },
            'app-browser-10b90': {
                'apiKey': 'AIzaSyDKwhFxY-zUq17InNmiluKyd5xxp8tAzP8',
                'authDomain': 'app-browser-10b90.firebaseapp.com',
                'databaseURL': 'https://app-browser-10b90.firebaseio.com',
                'projectId': 'app-browser-10b90',
                'storageBucket': 'app-browser-10b90.appspot.com',
                'messagingSenderId': '809240799935'
            }
        },
        // language: 'nl',
        language: 'en',
        languages: [
            {key: 'nl',value: 'Nederlands'},
            {key: 'en',value: 'English'},
        ],
        i18n: i18n,
        permissions: [ 'read',
            // 'create', 'read', 'update', 'delete', 'administrate', 'login', 'logout', 'autoLogin', 'fetchCredentials'],
            // 'create-node', 'read-node', 'update-node', 'delete-node',
            // 'create-post', 'read-post', 'update-post', 'delete-post',
        ],
        roles: {
            ANONYMOUS:      ['read'],
            // ANONYMOUS:      ['read', 'login','forceLogin'],  // override in app config for auth apps
            AUTHENTICATED:  ['read', 'create', 'update', 'logout'],
            EDITOR:         ['create', 'read', 'update', 'delete', 'logout'],
            DEVELOPER:      ['create', 'read', 'update', 'delete', 'logout', 'debug'],
            ADMINISTRATOR:  ['create', 'read', 'update', 'delete', 'administrate', 'logout', 'create-user', 'delete-user'],
            OWNER:          ['create', 'read', 'update', 'delete', 'administrate', 'logout', 'create-user', 'delete-user', 'debug', 'autoLogin', 'fetchCredentials'],
        }
};
